import React, { Component } from "react"
import Svg from "../_svgs/svg"
import Reveal from "react-awesome-reveal"
import Slider from "react-slick"

export default class NewsContainer extends Component {
  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
  }

  render() {
    const settings = {
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    if (this.props.news && this.props.news.length > 0) {
      const { titleAnimation, headingAnimation, subheadingAnimation, enableCarousel } = this.props

      return (
        <div className="news-block">
          <div className={`w--normal`}>
            {this.props.title ? (
              <Reveal
                keyframes={titleAnimation.type ? titleAnimation.type : null}
                className={titleAnimation.type ? "" : "disable-reveal"}
                duration={titleAnimation.duration}
                delay={titleAnimation.delay}
                fraction={1}
                triggerOnce
              >
                <div className={`infohead`}>{this.props.title}</div>
              </Reveal>
            ) : undefined}
            {this.props.heading ? (
              <Reveal
                keyframes={headingAnimation.type ? headingAnimation.type : null}
                className={headingAnimation.type ? "" : "disable-reveal"}
                duration={headingAnimation.duration}
                delay={headingAnimation.delay}
                fraction={1}
                triggerOnce
              >
                <div className={`heading`} dangerouslySetInnerHTML={{ __html: this.props.heading ? this.props.heading : "" }}></div>
              </Reveal>
            ) : undefined}
            {this.props.subHeading ? (
              <Reveal
                keyframes={subheadingAnimation.type ? subheadingAnimation.type : null}
                className={subheadingAnimation.type ? "" : "disable-reveal"}
                duration={subheadingAnimation.duration}
                delay={subheadingAnimation.delay}
                fraction={1}
                triggerOnce
              >
                <div className={`maintext`}>{this.props.subHeading}</div>
              </Reveal>
            ) : undefined}
            {window.innerWidth < 950 && enableCarousel ? (
              <div className="carousel">
                <Slider {...settings}>
                  {this.props.news.map((news, index) => {
                    const { type, delay, duration } = news.animation
                    return (
                      <Reveal key={index} keyframes={type ? type : null} className="" duration={duration} delay={delay} fraction={0.8} triggerOnce>
                        <div className="slide-content">
                          {news.image ? <img className="news-container-card" src={news.image || this.props.fallbackImage} /> : ""}
                          <div className="textarea">
                            <div className="date">{news.date}</div>
                            <h5>{news.heading}</h5>
                            <a href={news.link}></a>
                          </div>
                        </div>
                      </Reveal>
                    )
                  })}
                </Slider>
              </div>
            ) : (
              <div className="grid">
                {this.props.news.map((news, index) => {
                  let type,
                    delay,
                    duration = null
                  if (news.animation) {
                    type = news.animation.type
                    delay = news.animation.delay
                    duration = news.animation.duration
                  }
                  return (
                    <Reveal
                      key={index}
                      keyframes={type ? type : null}
                      className={type ? "grid-item col--12 col-sm--4" : "grid-item col--12 col-sm--4 disable-reveal"}
                      duration={duration}
                      delay={delay}
                      fraction={0.8}
                      triggerOnce
                    >
                      <a href={news.link}>
                        {news.image || this.props.fallbackImage ? (
                          <img className="news-container-card" src={news.image || this.props.fallbackImage} />
                        ) : (
                          ""
                        )}
                        <div className="textarea">
                          <div className="date">{news.date}</div>
                          <h5>{news.heading}</h5>
                        </div>
                      </a>
                    </Reveal>
                  )
                })}
              </div>
            )}
            {this.props.link && this.props.linkText && !enableCarousel ? (
              <a href={this.props.link} data-epi-property-name="Link" className="all-news-link">
                <Svg iconName={"arrowright-slim"} fillColor={"none"} renderContainer={false} />
                {this.props.linkText}
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      )
    }
    return ""
  }
}
